
const URL_PATTERN = /^https?:\/\/\w+([-+.]\w+)*(:\d+)?(\/[-_.\w]+)*\/?$/;
const KOR_TICKER_PATTERN = /^(krx|kosdaq):\d{6}$/i;
const US_TICKER_PATTERN = /^(NYSE|NASDAQ):\w{1,5}$/i;

export default class MiscValue {

    
    static numFormat(number, length) {
        return number.toString().padStart(length,"0");
    }

    static getLastDate(year, monthIndex) {
        if(monthIndex < 0) {
            year--;
            monthIndex = 11;
        }
        else if(monthIndex > 11) {
            year++;
            monthIndex = 0;
        }
        return new Date(year, monthIndex + 1, 0).getDate();
    }
    
    static getDateArraysToDisplayLikeCalendar(year, monthIndex) {
        const result = [];
        const firstDate = new Date(year, monthIndex, 1);
        const firstWeekDay = firstDate.getDay();
        const lastDate = MiscValue.getLastDate(year, monthIndex);
        let day = 1;
        while(day <= lastDate) {
            const week = [];
            let start = 0;
            if(day===1) {
                for(let i=0; i<firstWeekDay; i++) {
                    week.push(null);
                    start++;
                }
            }
            
            for(let i=start; i<7; i++) {
                if(day > lastDate) {
                    week.push(null);
                }
                else {
                    week.push(day);
                }
                day++;
            }
            result.push(week);
        }
        return result;
    }

    static dateToStrings(date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        return `${year}년 ${month}월 ${day}일`;
    }

    static getYMD(dateFrom, before) {
        const date = before ? new Date(dateFrom.getTime() - before * 86400000) : dateFrom;
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        return year + '-' + MiscValue.numFormat(month, 2) + '-' + MiscValue.numFormat(day, 2);
    }

    // make it comma separated number string
    static formatInt(num) {
        if(num) return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return num;
    }

    // make comma seperated floating point number string
    static formatFloat(num) {
        if(num) {
            const numStr = num.toString();
            if(numStr.includes('.')) {
                const parts = numStr.split('.');
                return MiscValue.formatInt(parts[0]) + '.' + parts[1];
            }
            return MiscValue.formatInt(num);
        }
        return num;
    }
        

    static isText(text) {
        return typeof text === 'string';
    }

    static isGoodTicker(ticker) {
        if(KOR_TICKER_PATTERN.test(ticker) || US_TICKER_PATTERN.test(ticker)) {
            return true;
        }
        return false;
    }
}